<template>
  <div id="app">
    <router-view />
    <div v-if="isQaMode" class="qa-banner" role="status">
      Ambiente de pruebas de ThinkSign: ninguna firma es real
    </div>
  </div>
</template>

<script setup>
// La aplicación ahora usa el router para manejar las diferentes páginas
const isQaMode = import.meta.env.VITE_APP_MODE === "qa";
if (isQaMode && typeof document !== "undefined") {
  document.title = `[QA] ${document.title}`;
}
</script>

<style>
/* Estilos globales mejorados */
* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
  background-color: var(--va-background-primary);
  color: var(--va-text-primary);
}

#app {
  height: 100vh;
  overflow: hidden;
}

/* Marca permanente del ambiente de pruebas (VITE_APP_MODE=qa). No altera el
   layout: flota sobre el contenido y no captura clics. */
.qa-banner {
  position: fixed;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  z-index: 10000;
  padding: 6px 16px;
  border-radius: 999px;
  background: #b45309;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

/* Cards mejoradas */
.va-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--va-background-border);
  transition: all 0.2s ease;
}

.va-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
</style>
